import { useEffect } from "react";
import { useSocket } from "../lib/socketProvider";
import { useNotificationStore } from "../store/useNotificationStore";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { Bell } from "lucide-react";

const NotificationListener = () => {
  const socket = useSocket();
  const { incrementUnreadCount, getUnreadCount } = useNotificationStore();
  const location = useLocation();
  const isMessagePage = location.pathname.includes("/messages");

  useEffect(() => {
    if (!socket) return;

    // Initial fetch of unread count
    getUnreadCount();

    // Listen for new messages
    const handleNewMessage = (message) => {
      incrementUnreadCount();
      
      if (!isMessagePage) {
        toast.custom((t) => (
          <div
            className={`${
              t.visible ? "animate-enter" : "animate-leave"
            } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
          >
            <div className="flex-1 w-0 p-4">
              <div className="flex items-start">
                <div className="flex-shrink-0 pt-0.5">
                  <Bell className="h-10 w-10 text-[#c3a27f]" />
                </div>
                <div className="ml-3 flex-1">
                  <p className="text-sm font-medium text-gray-900">
                    New Message
                  </p>
                  <p className="mt-1 text-sm text-gray-500">
                    {message.text || "You have a new message"}
                  </p>
                </div>
              </div>
            </div>
            <div className="flex border-l border-gray-200">
              <button
                onClick={() => toast.dismiss(t.id)}
                className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-[#c3a27f] hover:text-[#b78c61] focus:outline-none"
              >
                Close
              </button>
            </div>
          </div>
        ), {
          duration: 5000,
          position: "top-right",
        });
      }
    };

    // Subscribe to newMessage events
    socket.on("newMessage", handleNewMessage);

    // Cleanup on unmount
    return () => {
      socket.off("newMessage", handleNewMessage);
    };
  }, [socket, incrementUnreadCount, getUnreadCount, isMessagePage]);

  return null; // This component doesn't render anything
};

export default NotificationListener; 